<template>
  <div style="height: 100%;">
    <werktijd-progress v-if="bezig_met_inladen"></werktijd-progress>
    <v-form v-if="d">
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <h3 style="margin-bottom: 1em; font-weight: bold;">{{ d.titel }}</h3>
            <p v-for="msg in d.foutmeldingen" style="color: red;">{{ msg }}</p>
          </v-flex>
          <v-flex xs12 v-if="d.telewerk">
            <p>Vink aan welke tijdsregistraties als telewerk mogen beschouwd worden: (<a href="#" @click.prevent="allesTelewerk">alles</a>)</p>
            <v-checkbox v-for="tr in d.telewerk" :key="tr.id" v-model="tr.v" :label="tr.omschr"></v-checkbox>
          </v-flex>
          <v-flex xs12 v-if="d.wwv">
            <p>Woon-werkverkeer:</p>
            <v-radio-group v-model="d.wwv.keuze">
              <v-radio v-for="o in d.wwv.opties" :key="o.id" :value="o.id" :label="o.label"></v-radio>
            </v-radio-group>
            <v-textarea v-model="d.wwv.opm" rows="1" :auto-grow="true" label="Opmerkingen over woon-werkverkeer"></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
      <div style="text-align: center; margin: 0;">
        <v-btn color="success" @click="opslaan" default>Opslaan</v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import WerktijdProgress from './WerktijdProgress'
  export default {
    components: { WerktijdProgress },
    data: () => ({
      bezig_met_inladen: true,
      d: null
    }),
    computed: {
      ...mapState(['api']),
      jsDatum: () => { return new Date(this.$route.params.datum) }
    },
    methods: {
      ...mapMutations(['setSnackbarMsg', ]),
      laden: async function() {
        this.bezig_met_inladen = true
        let r = await this.api.get('/wwv_tw/' + this.$route.params.datum)
        this.d = r.data
        this.bezig_met_inladen = false
      },
      opslaan: async function() {
        this.bezig_met_inladen = true
        let r = await this.api.post('/wwv_tw/' + this.$route.params.datum, this.d)
        if (r.data.saved) {
          this.setSnackbarMsg(r.data.msg)
          this.$router.push('/')
        } else {
          this.d = r.data
        }
        this.bezig_met_inladen = false
      },
      allesTelewerk: function() {
        for (let tr of this.d.telewerk) {
          tr.v = true
        }
      }
    },
    watch: {
      '$route': function() {
        this.laden()
      }
    },
    mounted() {
      this.laden()
    }
  }
</script>

<style lang="stylus">
  .v-input
    margin-top: 0

  p
    font-size: 16px

  .v-input--checkbox.v-input--selection-controls .v-input__slot
    margin: 0

  .v-input--checkbox label.v-label.theme--light,
  .v-radio label.v-label.theme--light
    color: black
</style>
